module.exports = __webpack_public_path__ + "assets/img/fc62-lr.svg";